export const strings = {
    agree: 'Aceptar',
    disagree: 'Cancelar',
    close: 'Cerrar',
    continue: 'Continuar',
    minimumAllowedPackageSize:
        'Medidas mínimas permitidas\nAlto: 2cm x Largo: 10cm x Ancho: 10cm',
    cantOperate:
        'En las próximas 48-72hs vas a poder empezar a operar. Click para mas información...',
    customerDisabled:
        'Pudo Smart Lockers se encuentra deshabilitado. Para operar tenes habilitarlo desde la configuración de envíos.',
    pendingValidation:
        'Para empeza a operar tenes que validar tus datos de facturacion. Click aquí para validar tus datos.',
    infoDialogText:
        'Ya casi estás listo para poder trabajar con PUDO.\n' +
        'Vamos a validar tus datos y ajustar todo para que puedas usar el servicio. No te preocupes por nada, nosotros nos encargamos.\n' +
        'Cualquier consulta, estamos para escucharte.',
    country: 'País',
    province: 'Provincia',
    city: 'Ciudad',
    locality: 'Localidad',
    streetAddress: 'Calle',
    streetNumber: 'Número',
    floor: 'Piso',
    apartment: 'Departamento',
    postalCode: 'Código Postal',
    monday: 'lunes',
    tuesday: 'martes',
    wednesday: 'miércoles',
    thursday: 'jueves',
    friday: 'viernes',
    saturday: 'sábado',
    sunday: 'domingo',

    shopType: 'Rubro',
    locker: 'Locker',
    nothingSelected: 'nada seleccionado',
    addressInfoDialogFloor: 'Piso (Opcional)',
    addressInfoDialogLocality: 'Localidad (Opcional)',
    addressInfoDialogApartment: 'Departamento (Opcional)',

    shopName: 'Nombre de la tienda',
    shopNamePlaceholder: 'Ej. Ricardo Calzados',
    shopNameNotValid: 'Ya existe un shop con ese nombre.',

    cityPlaceholder: 'Ej. Ciudad Autónoma de Buenos Aires',
    localityPlaceholder: 'Ej. Parque Chacabuco',
    streetAddressPlaceholder: 'Ej. Callao',
    streetNumberPlaceholder: 'Ej. 234',
    floorPlaceholder: 'Ej. 7',
    apartmentPlaceholder: 'Ej. S',
    postalCodePlaceholder: 'Ej. 1051',
    phoneNumberPlaceholder: 'Ej. 1199995555',
    emailPlaceholder: 'Ej. correo@dominio.com',
    phoneNumber: 'Teléfono',
    email: 'Correo electrónico',
    clientEmail: 'Correo electrónico del cliente',
    clientPhoneNumber: 'Teléfono del cliente',
    passwordLengthHint: 'Mínimo 5 caracteres',
    passwordUpperCaseHint: 'Incluír una letra Minúscula',
    passwordLowerCaseHint: 'Incluír una letra Mayúscula',
    passwordNumberHint: 'Incluír un número',
    phoneNumberHint:
        'El número de teléfono debe tener 10 dígitos, sin 0, ni 15, ni código de país',

    // EULA
    eulaTitle: 'Términos y condiciones',
    eulaAccepted:
        'He aceptado los Términos y Condiciones expresadas del presente.',

    // CONTACT
    contactTitle: 'Contáctenos',
    contactPageTitle: 'Contacto',
    contactPhoneText:
        'Para realizar consultas, reclamos o sugerencias, comunicate sin cargo a nuestro centro de atención al cliente',
    contactEmailText:
        'Para realizar consultas, reclamos o sugerencias, comunicate enviándonos un correo electrónico',
    contactLocationText: 'Central Pudo',
    contactWebText: 'Para más información',

    // Config
    configSaveButton: 'Guardar',
    freeShippingDetails:
        'Si al menos uno de los productos tiene envío gratis, todo el envío será gratis para el comprador',
    productConfigurationBanner:
        'Aqui podras configurar el precio del servicio para el comprador',

    // LogIn
    logInFormTitle: 'Ingresar',
    logInUserName: 'Usuario/Mail',
    logInPassword: 'Contraseña',
    logInButton: 'Ingresar',
    logInRegister: 'Registrá tu tienda',
    logInInstallApps: 'Instalá la App de tu tienda',
    seeEcommerceDocumentation: 'Ver documentación',

    // Ecommerce Documentation
    ecommerceDocumentation: {
        ecommerceDocumentation: 'Documentación de Ecommerce',
        introPudo: 'PUDO ARGENTINA S.A',
        introTitle: 'Documento Técnico',
        introSubtitle: 'ECommerce API',
        introText: 'El presente documento describe la interfaz de aplicación para acceder al sistema de logística de ECommerce de Pudo. Mediante esta API es posible consultar cotizaciones, crear órdenes, consultar órdenes y otras funcionalidades.',
        example: 'Ejemplo',
    },

    // Toolbar
    toolbarChangePasswordButton: 'Cambiar contraseña',
    toolbarLogOutButton: 'Cerrar sesión',

    // Change Password
    changePasswordTitle: 'Cambiar contraseña',
    changePasswordDescription:
        'Ingresá todos los datos para cambiar tu contraseña.',
    changePasswordOld: 'Contraseña actual',
    changePasswordNew: 'Nueva contraseña',
    changePasswordNewRetry: 'Confirmar contraseña',
    changePasswordSubmit: 'Cambiar',
    changePasswordSuccessTitle: 'Listo!',
    changePasswordSuccess: 'Se cambió la contraseña!',
    changePasswordFailed:
        'No se pudo realizar el cambio, verificá los datos ingresados.',

    // Tracking
    trackingTitle: 'Seguimiento de Orden',

    // Shopify
    shopifyAuthResultTitle: 'Shopify Auth Result',
    shopifyLogInTitle: 'Shopify Log In',

    // Tiendanube
    tiendanubeAutorizeTitle: 'Tiendanube',

    // WooCommerce
    wooCommerceTitle: 'WooCommerce',
    wooCommercePermissionsDenied:
        'Por favor, habilite los permisos de acceso a su tienda para poder operar.',

    // WooCommerceHelp
    wooCommerceHelpTitle: 'Instalación en WooCommerce',
    wooCommerceGetManual: 'Descarga el manual de instalación del plugin',
    wooCommerceGetApp: 'Descarga la última version del plugin (.zip)',

    // ShopifyHelp
    shopifyHelpTitle: 'Instalación en Shopify',
    shopifyHelpInstallInstructions:
        'Ingresa el nombre de tu tienda como lo registraste en Shopify',
    shopifyHelpShopNameLabel: 'Nombre de Tienda',
    shopifyHelpShopNamePlaceholder: 'Ej. topstore o topstore.myshopify.com',
    shopifyHelpAfterInstallInstructions:
        'Si ya instalaste la app o necesitas ayuda, contactate con nosotros a {{mailAddress}}',
    shopifyHelpAfterInstallMailAddress: 'comercial@pudolatam.com',
    shopifyHelpAfterInstallMailSubject: 'Instalacion de App en Shopify',
    shopifyHelpAfterInstallMailBody:
        'Ya instale la aplicacion en mi tienda {{shopName}} y necesito ayuda para configurarla',
    shopifyHelpAfterInstallMailBodyWithoutShopName:
        'Necesito ayuda para instalar la aplicación',

    // BillingMovements
    movements_title: 'Movimientos',
    movements_dateFrom: 'Desde',
    movements_dateTo: 'Hasta',
    movements_search: 'Buscar',
    movements_notFoundData: 'No se encontraron resultados',
    movements_foundData: 'Conceptos',
    movements_serviceNameLabel: 'Servicio',
    movements_shippingMethodLabel: 'Método de envío',
    movements_sourceLabel: 'Origen',
    movements_destinationLabel: 'Destino',
    movements_countLabel: 'Cantidad',
    movements_noVatAmountLabel: 'Costo S/IVA',
    movements_totalNoVatAmountLabel: 'Subtotal S/IVA',
    movements_totalAmountLabel: 'Subtotal c/IVA',
    movements_totalCount: 'Hay {{totalCount}} movimientos.',
    movements_totalRows: 'Resumidos en {{totalRows}} grupos.',
    movements_download: 'Descargar detalle',
    movements_totals_title: 'Totales',
    movements_totals_totalAmount: 'Total con IVA',
    movements_totals_totalAmountNoVatLabel: 'Total sin IVA',
    movements_totals_totalCountLabel: 'Cantidad de paquetes',

    //General
    costDisclaimer: 'Aplican cargos sobre excedente de peso',
    address: 'Dirección',
    // Price
    priceTitle: 'Precios',

    // Config
    configTitle: 'Configuración',
    generalConfigTitle: 'General',
    generalConfigShowAddressInLabel: 'Mostrar dirección de la tienda en la etiqueta',
    insuranceConfigTitle: 'Seguro',
    insuranceConfigDefaultValue: 'Asegurar cada orden por ($0 = sin seguro):',
    insuranceConfigItemsTotal: 'Asegurar cada orden por el total de su valor',
    apiCredentialsTitle: 'Credenciales API',
    apiCredentialsClientId: 'Client ID',
    apiCredentialsClientSecret: 'Client Secret',
    apiCredentialsClientSecretChangeTooltip: 'Generar nuevo Client Secret',
    apiCredentialsClientSecretChangeMessage: 'Está a punto de cambiar el Client Secret, esto puede afectar la integracíón con su eCommerce.',
    apiCredentialsClientSecretChangeOkLabel: 'Gernerar nuevo Client Secret',
    apiCredentialsClientIdSandbox: 'Client ID (Sandbox)',
    apiCredentialsClientSecretSandbox: 'Client Secret (Sandbox)',
    wooCommerceConfigTitle: 'WooCommerce',
    wooCommerceConfigSecret: 'Código',
    configNotificationTemplateErrorTitle: 'Archivo incorrecto',
    configNotificationTemplateErrorLength: 'El tamaño de la imagen no cumple con los requisitos',
    configNotificationTemplateErrorSize: 'La medida de la imagen no cumple con los requisitos',
    configNotificationTemplateTitle: 'Personalizar Template',
    configNotificationTemplateEmail: {
        accept: 'Aceptar',
        cancel: 'Cancelar',
        delete: 'Eliminar',
        // Email preview
        templateEmailEditor: 'Editar plantilla de email',
        reservationConfirmedTitle: '¡Reserva confirmada!',
        reservationConfirmedPrefix: 'Tu reserva',
        reservationConfirmedSuffix: 'está confirmada',
        selectedLockerLabel: 'El SmartLocker que elegiste es:',
        thankYouForUseSmartLockers: 'Gracias por utilizar nuestros servicios de SmartLockers',
        contactUsMessage: 'Ante cualquier duda comunicate con nosotros:',
        emailNotificationsDisclaimer: 'Se envió este correo electrónico desde una dirección exclusiva de notificaciones que no recibe correos electrónicos. No respondas a este mensaje',
        // emailTemplateCustomizer
        // Logo
        uploadLogo: 'Subí tu logo',
        logoFormats: 'PNG, JPG, SVG',
        deleteLogo: '¿Eliminar el logo?',
        changeLogo: 'Cambiar logo',
        deleteLogo: 'Eliminar logo',
        // Color
        changeColor: 'Cambiar color',
        selectColor: 'Seleccionar color',
        // Confirmación al cerrar
        discardChangesTitle: '¿Descartás los cambios?',
        discardChangesMessage: 'Tenés cambios sin guardar en el editor de email. Si cerrás ahora se perderán.',
        continueEditing: 'Seguir editando',
        discardChanges: 'Descartar cambios',
        // Recorte
        cropLogo: 'Recortar logo',
        zoom: 'Zoom',
        cropLogoHelp: 'Ajustá el recorte para mostrar la parte del logo que querés en el email. Usá el slider o la rueda del mouse para cambiar el zoom.',
        cropImageError: 'No se pudo procesar la imagen. Intentá con otra.',
        processing: 'Procesando…',
        applyCrop: 'Aplicar recorte',
        // Errores de carga
        invalidFileTitle: 'Archivo inválido',
        invalidFileMessage: 'Solo se permiten imágenes (PNG, JPG, etc.).',
        fileReadError: 'No se pudo leer el archivo.',
        onlyImagesAllowed: 'Solo se permiten imágenes.',
        // Editor
        emailCustomization: 'Personalización de Email',
        unsavedChanges: 'Cambios sin guardar',
        brand: 'Marca',
        logo: 'Logo',
        primaryColor: 'Color principal',
        email: 'Email',
        subjectPrefix: 'Prefijo de asunto',
        subjectPrefixPlaceholder: 'ej. [EMPRESA]',
        subjectPrefixHelper: 'Aparece al inicio del asunto de cada email.',
        emailPreview: 'Vista previa del email',
        subject: 'Asunto:',
        confirmedReservationSubject: 'Reserva confirmada',
    },
    configNotificationTemplateLogo: 'Logo a mostrar en los correos',
    configNotificationTemplateLogoSpecs: 'Especificaciones: Formato PNG, ancho {{width}}px, alto {{height}}px y peso máximo {{maxSize}}kb.',
    configNotificationTemplateLogoButtonUp: 'Subir logo',
    configNotificationTemplateLogoButtonRem: 'Quitar logo',
    configNotificationTemplateSubjectPrefix: 'Prefijo a mostrar en el asunto de los correos',
    configNotificationTemplateSmsCourier: 'Nombre a mostrar en mensajes de texto (SMS)',
    configLockerTitle: 'Personalización del Locker',
    configLockerSecurityCodeTitle: 'Título de código de seguridad',

    cost: 'Costo del servicio',
    productHeaderProduct: 'Producto',
    productHeaderCost: 'Costo',
    productHeaderPrice: 'Precio a Cobrar',
    copyTooltip: 'Copiar',
    lockerAmount: 'Cantidad máxima de lockers',
    saveErrorTitle: 'Configuración',
    saveSuccessTitle: 'Configuración',
    saveSuccessDialog: 'Se guardaron los datos',
    saveErrorDialog: 'Ocurrió un error al guardar los datos',
    sendSmsSuccessDialog: 'Se envió el código de retiro',
    sendSmsErrorDialog: 'Ocurrió un error al enviar el código de retiro',

    // ServiceAreaConfig
    serviceAreaConfigTitle: 'Métodos de Envío',
    serviceAreaConfigHeader: 'Configuración de áreas de servicio',
    serviceAreaNoMethodsAvailable: 'No ténes metodos de envío disponibles.\nComunicate con Pudo a la brevedad.',

    // Orders
    ordersTitle: 'Listado de órdenes',
    importSheetFile: 'Importar archivo de órdenes',
    ordersSubmitButton: 'Buscar',
    ordersExportButton: 'Descargar órdenes',
    ordersGetMore: 'Mostrar más',
    ordersOrderNumberLabel: 'Busqueda',
    ordersOrderNumberTooltip: 'Se puede buscar por nro. de orden, identificador, código de depósito o por nro. de seguimiento',
    ordersOrderNumberLabelPlaceholder: '',
    ordersFromDateLabel: 'Desde',
    ordersToDateLabel: 'Hasta',
    ordersGridTrackingNumberLabel: 'Seguimiento',
    ordersGridDepositCodeLabel: 'Código',
    ordersGridEmailLabel: 'Contacto',
    ordersGridDateLabel: 'Fecha',
    ordersGridStateLabel: 'Estado',
    ordersGridCostLabel: 'Costo desde',
    ordersGridPhoneLabel: 'Teléfono',
    ordersGridPhoneShortLabel: 'Tel',
    ordersGridNotFoundData: 'No se encontraron resultados',
    ordersShippingMethodLabel: 'Método envío',
    ordersGridItemsTotalAmountLabel: 'Precio del Producto',
    ordersGridInsuredValueLabel: 'Valor asegurado',
    ordersGridPrimeOfInsuredValueLabel: 'Costo del seguro',
    ordersGridprimeOfInsuredValue: 'Seguro',

    doorSizeSelector_button: 'Puerta',
    doorSizeSelector_button_null: 'Seleccionar puerta',
    doorSizeSelector_title: 'Seleccionar tamaño de puerta',
    doorSizeSelector_text: 'Teniendo en cuenta las medidas del paquete, seleccioná el tamaño de puerta que se adapte a tus necesidades.',
    doorSizeSelector_minimumSize: 'Medidas mínimas permitidas\nAlto: 2cm x Largo: 10cm x Ancho: 10cm',
    doorSizeSelector_resultOkTitle: 'Listo!',
    doorSizeSelector_resultOk: 'Se realizaron los cambios correctamente',
    doorSizeSelector_noDoorSizeAvailable: 'Momentaneamente no hay puertas disponibles. Reintente luego.',

    orderReserveButton: 'Depositar en el Smart Locker',
    orderReserveDialogTitle: 'Depositar en el Smart Locker',
    orderReserveDoorDialogText: 'Al seleccionar esta opción, vos mismo vas a depositar la orden en el Smart Locker.\n',
    orderReserveNoDoorDialogText: 'Para poder depositar en el Smart Locker primero tenés que asignarle un tamaño de puerta según las medidas del paquete.',
    orderReserveDialogText: 'Al seleccionar esta opción, vos mismo vas a depositar la orden en el Smart Locker.\nEs sencillo, solo tenés que elegir un tamaño de puerta donde entre la orden.\nSi querés que PUDO se encargue de depositar el paquete, elegí "Cerrar " y seleccioná la opción "Paquete listo para recolección".\n\n',
    orderReserveSuccessTitle: 'Listo!',
    orderReserveSuccess: '¡Ya podes ir a depositar al locker!\nAcordate que depositas usando el QR de la etiqueta.\n',
    orderReserveNoDoorSizeAvailable: 'Momentaneamente no hay puertas disponibles. Reintente luego.',

    orderReserveDispatchToLockerDialogText: 'Al seleccionar esta opción, vos mismo vas a depositar la orden en el Smart Locker.\nEs sencillo, solo tenés que elegir un tamaño de puerta donde entre la orden.\nPara depositar en el locker tenes usar el QR de la etiqueta de la orden de despacho.\n',
    orderReserveDispatchToLockerSuccess: '¡Ya podes ir a depositar al locker!\nAcordate que depositas usando el QR de la etiqueta.\n',

    orderCancelButton: 'Cancelar orden',
    orderCancelDialogTitle: 'Cancelar la orden',
    orderCancelDialogText: 'Está a punto de cancelar la orden seleccionada.\nUna vez cancelada no se podrá volver atrás.',
    orderCancelSuccessTitle: 'Listo!',
    orderCancelResultCancelled: 'Se canceló la orden',
    orderCancelResultCanNotBeCancelled: 'No se puede cancelar la orden',
    orderCancelResultWaitingIncidenceResolution:
        'Cancelación pendiente de resolucion',
    orderCancelResultUnknown: 'Resultado desconocido',

    orderCancelAllButton: 'Cancelar órdenes',
    orderCancelAllDialogTitle: 'Cancelar órdenes',
    orderCancelAllDialogText:
        'Está a punto de cancelar las órdenes seleccionadas.\nUna vez canceladas no se podrá volver atrás.',
    orderCancelAllSuccessTitle: 'Listo!',
    orderCancelAllResultCancelled: 'Se cancelaron las ordenes',
    orderCancelAllResultCanNotBeCancelled: 'No se pueden cancelar las órdenes',
    orderCancelAllResultWaitingIncidenceResolution:
        'Cancelación pendiente de resolucion',
    orderCancelAllResultUnknown: 'Resultado desconocido',

    orderExtendButton: 'Extender Reserva',
    orderExtendDialogTitle: 'Extender la Reserva',
    orderExtendDialogText:
        'El tiempo a extender indica el período disponible para retirar el paquete hasta el próximo vencimiento. Una vez superado, el cliente deberá efectuar otra extensión mientras sea posible.',
    orderExtendSuccessTitle: 'La extensión ha sido realizada correctamente',
    orderExtendDialog_currentDate: 'Fecha actual',
    orderExtendDialog_lastValidDate: 'Fecha expirada',
    orderExtendDialog_validTo: 'Nueva fecha válida',
    orderExtendDialog_periodToExtend: 'Tiempo a extender(*)',
    orderExtendDialog_amount: 'Costo extra',
    orderExtendDialog_referenceId: 'Referencia #',
    orderExtendDialog_expirationDate: 'Expira',
    orderExtendDialog_daysExtended: 'Días extendidos',

    orderInsureButton: 'Asegurar orden',
    orderInsureDialogTitle: 'Asegurar orden',
    orderInsureExceedsItemsValue:
        'El monto no puede superar el valor de los items',
    orderInsureIsNaNValue: 'El monto actual no es válido',
    orderInsureIsMaximum: 'El monto es superior al valor máximo asegurable.',
    orderInsureInvalidInput: 'El monto debe ser mayor o igual a 0.',
    orderInsureIsMinimum: 'El monto es inferior al valor mínimo asegurable.',
    orderInsureInsuredValueLabel: 'Monto a asegurar',
    orderInsureInsuredPrimeLabel: 'Costo del seguro',
    orderInsureItemsAmountLabel: 'Monto total de la orden ($ {{value}})',
    orderInsureInfo:
        'Mínimo valor asegurable: $ {{minimum}}\n Máximo valor asegurable: $ {{maximum}}\n Costo del seguro: {{premium}}%',
    orderInsureMaxValue: 'Máximo valor asegurable: $ {{maximum}}',
    orderInsureSuccessTitle: 'Listo!',
    orderInsureSuccess: 'Se modificó el valor asegurado de la orden.',

    orderReturnButton: 'Devolver el paquete',
    orderReturnSuccessTitle: 'Listo!',
    orderReturnSuccess: 'Ahora el paquete se encuentra listo para su devolución',
    orderReturnDialogTitle: 'Devolver el paquete',
    orderReturnDialogText:
        'Si continúa se creará una orden para devolución del paquete cuyo origen sera el lugar donde fue entregado.',
    orderReturnDialogLockerTextInfo: 'Lugar de devolución',
    orderReturnDialogShipToAddressTextInfo: 'Domicilio de retiro',

    editAddressButton: 'Editar Dirección',
    editAddressSuccessTitle: 'Listo!',
    editAddressSuccess: 'La dirección fue cambiada.',
    editAddressDialogTitle: 'Editar Dirección',
    editAddressDialogSave: 'Guardar cambios',

    selectSimplePlaceholder: 'Elegí una opción',
    selectSimpleNoOptionsMessage: 'No encontramos la opción: ',

    editAddressStreetName: 'Calle',
    editAddressStreetNamePlaceholder: 'Ej. Callao',
    editAddressStreetNumber: 'Altura',
    editAddressStreetNumberPlaceholder: 'Ej. 234',
    editAddressStreetNumberEmpty: 'Sin número',
    editAddressFloor: 'Piso (Opcional)',
    editAddressFloorPlaceholder: 'Ej. 7',
    editAddressApartment: 'Apartamento (Opcional)',
    editAddressApartmentPlaceholder: 'Ej. S',
    editAddressLocality: 'Localidad (Opcional)',
    editAddressLocalityPlaceholder: 'Ej. Parque Chacabuco',
    editAddressCity: 'Ciudad (Opcional)',
    editAddressCityPlaceholder: 'Ej. Ciudad Autónoma de Buenos Aires',

    orderReadySuccess: 'Ahora el paquete se encuetra listo para su recolección',
    orderReadyDialogTitle: 'Paquete listo para recolección',
    orderReadyDialogText: 'Si continúa el paquete se pondrá en estado listo para recolección. \n Esta acción es irreversible.',
    orderReadyButton: 'Paquete listo para recolección',
    orderReadySuccessTitle: 'Listo!',
    addOrderToGroupDialogText: 'El mínimo para solicitar recolección es de {{minimumOrders}} paquetes. \n Si continúa el paquete se sumará a su lista de pendientes de recolección hasta alcanzar la cantidad necesaria.',
    orderReadyConfirmPickUp: 'Confirmar retiro de {{ordersGrouped}} paquete/s',
    ordersReadyDialogText: 'Si continúa los paquetes se pondrán en estado Listo para recolección. \n Esta acción es irreversible.',
    pickupLimit: '* Debe agregar {{remainingOrders}} órden/es más para cumplir con el mínimo establecido',

    addOrderToGroupButton: 'Paquetes listos para recolección',
    addOrderToGroupDialogTitle: 'Paquetes listos para recolección',
    orderReadyAllDialogText:
        'Si continúa los paquetes seleccionados se pondrán en estado listo para recolección.',
    orderReadyAllSuccessTitle: 'Listo!',
    orderReadyAllSuccess:
        'Ahora los paquetes se encuetran listos para su recolección',
    orderReadyAllErrorTitle: 'Listo!!',
    orderReadyAllError:
        'Ahora los paquetes se encuetran listos para su recolección',

    removeOrder: 'Quitar de la lista de retiros',
    removeOrderDialogTitle: 'Quitar paquete de la lista de retiros',
    removeOrderDialogText: 'El paquete se eliminará de la lista de retiros pendientes',

    downloadOrderAllButton: 'Descargar etiquetas',
    downloadOrderAllDialogTitle: 'Descargar etiquetas',
    downloadOrderAllDialogText:
        'Vas a descargarán las etiquetas de las órdenes seleccionadas.\nElegi el formato:',
    downloadOrderAllProgressMessage: 'Preparando etiquetas\nAguarde por favor',

    downloadOrderAllPrintButton: 'Imprimir etiquetas',
    downloadOrderAllPrintDialogTitle: 'Imprimir etiquetas',
    downloadOrderAllPrintDialogText:
        'Vas a imprimir las etiquetas de las órdenes seleccionadas.\nElegi el formato',
    downloadOrderAllSuggestion:
        'Si tenes una impresora de etiquetas, elegi 1 etiqueta por pagina.\nAl momento de imprimir configura el tamaño de pagina con las dimensiones de la etiqueta que uses.',
    downloadOrderPerPage: 'etiqueta por página',
    downloadOrderPerPages: 'etiquetas por página',

    downloadOrderButton: 'Descargar etiqueta',
    downloadOrderDialogTitle: 'Descargando',

    printOrderButton: 'Imprimir etiqueta',
    printOrderDialogTitle: 'Imprimiendo',
    contactTimeButton: 'Rango horario',
    contactTimeDialogTitle: 'Rango horario',
    contactTimeErrorTitle: 'Error al agregar horario',
    contactTimeError: 'No se pudo asignar el rango horario',
    contactTimeRangeError: 'La hora de fin debe ser postarior a la hora de inicio',
    contactTimeSuccessTitle: 'Listo!',
    contactTimeSuccess: 'Operación realizada con éxito',

    viewOrderButton: 'Seguimiento',
    paginatorCount: 'Hay {{count}} registros,',
    paginatorRowsPerPage: 'por página',

    recoveryOrder: 'Rescatar paquete',
    recoveryOrderTitle: 'Código para rescatar el paquete',
    recoveryOrderReservationId: 'ID Reserva: #',
    recoveryOrderPrint: 'Imprimir',
    recoveryOrderDownload: 'Descargar',

    printDeliveryReceipt: 'Imprimir comprobante de entrega',
    downloadDeliveryReceipt: 'Descargar comprobante de entrega',

    cancelDepositedParcel: 'Cancelar con paquete depositado',
    cancelDepositedParcelTitle: 'Cancelar orden con paquete depositado',
    cancelDepositedParcelSubtitle: 'La cancelación ya está en trámite',

    //Registracion
    registrationFormTitle: 'Registrarse',
    registrationHeader: 'Ingresá tus datos para completar el registro.',
    registrationPassword: 'Contraseña',
    registrationPasswordConfirmation: 'Confirmar contraseña',
    registrationAddressUpdateButton: 'Modificar',
    registrationWarehouseAndBillingAddress:
        'Dirección del depósito y facturación',
    registrationWarehouseAddress: 'Dirección del depósito',
    registrationWarehouseAndBillingAddressHint:
        'Puede seleccionar otra direccion de seleccionela en Facturacion',
    registrationBillingAddress: 'Dirección de facturación',
    registrationShowBillingAddress: 'Seleccionar otra dirección para facturar',
    registrationAddressError:
        'Debe completar todos los datos para poder continuar',

    registrationFormShopHeader: 'Tienda',
    registrationFormUserHeader: 'Usuario',

    warehouseContact_title: 'Contacto para despacho',
    warehouseContact_name: 'Nombre y Apellido',
    warehouseContact_namePlaceholder: 'Ej. Roberto Rodriguez',
    warehouseContact_mail: 'Correo',
    warehouseContact_mailPlaceholder: 'Ej. contacto@micorreo.com',
    warehouseContact_phoneNumber: 'Teléfono',
    warehouseContact_phoneNumberPlaceholder: 'Ej. 1122223333',

    billingInformation_title: 'Facturación',
    billingInformation_cuit: 'CUIT',
    billingInformation_cuitPlaceholder: 'Ej. 00111111110',
    billingInformation_businessName: 'Razón Social',
    billingInformation_businessNamePlaceholder: 'Ej. Roberto Rodriguez S.A.',
    billingInformation_taxingCategory: 'Condición Fiscal',
    billingInformation_successTitle: 'Listo!',
    billingInformation_oldCuitNotFound:
        'El CUIT ingresado anteriormente no es válido',
    billingInformation_failValidation: 'El CUIT no pudo ser validado',

    pickupSchedule_title: 'Horario de despacho',
    pickupSchedule_startTime: 'desde las',
    pickupSchedule_endTime: 'hasta las',
    pickupSchedule_theDays: 'Los dias',

    //Lockers Map
    lockersMapFormTitle: 'Lockers disponibles',

    //Reset Password
    resetPasswordFormTitle: 'Recuperación de contraseña',
    resetPasswordLink: 'Olvidé mi contraseña',

    resetPasswordAssignmentConfirm: 'Continuar',
    resetPasswordAssignmentTitle: 'Crear contraseña',
    resetPasswordAssignmentDescription:
        'Ingresá todos los datos para crear su contraseña.',
    resetPasswordAssignmentSuccessTitle: 'Listo!',
    resetPasswordAssignmentSuccess: 'Se creó la contraseña!',
    resetPasswordAssignmentFailed:
        'No se pudo crear la nueva contraseña, verificá los datos ingresados.',
    resetPasswordAssignmentNew: 'Nueva contraseña',
    resetPasswordAssignmentNewRetry: 'Confirmar contraseña',

    resetPasswordRequesConfirm: 'Continuar',
    resetPasswordRequestTitle: 'Recuperación de contraseña',
    resetPasswordRequestDescription:
        'Ingresá tu e-mail. Luego verificá tu casilla de correo electrónico.',
    resetPasswordRequestSuccessTitle: 'Listo!',
    resetPasswordRequestSuccess: 'Mail enviado, verificá tu casilla de correo',
    resetPasswordRequestFailed:
        'No se pudo enviar el correo, vuelva a intentarlo mas tarde.',
    resetPasswordRequestEmail: 'Correo electrónico',

    // Contact
    contactFormTitle: 'Contacto',

    contactHeader:
        'Para contactarte rellená este formulario y envíalo.\n Nos comunicaremos a la brevedad.',
    contactName: 'Nombre y Apellido',
    contactNamePlaceholder: 'Ej. Roberto Rodriguez',
    contactMail: 'Correo',
    contactPhoneNumber: 'Teléfono',
    contactPreferredContactFromTime: 'Contactarse desde',
    contactPreferredContactToTime: 'Contactarse hasta',
    contactSubmitButton: 'Enviar',
    contactSendContactSuccessTitle: 'Enviado',
    contactSendContactSuccess:
        'El formulario de contacto se ha enviado correctamente.',
    contactSearchButton: 'Buscar',
    contactPhoneNumberPlaceholder: 'Ej. 1122223333',
    contactMailPlaceholder: 'Ej. contacto@micorreo.com',
    billingInformation_contactMail: 'Correo administrativo',
    billingInformation_contactMailPlaceholder: 'Ej. contacto@micorreo.com',
    billingInformation_contactMailCheck: 'Utilizar el correo de usuario',
    mailHint: 'Se debe ingresar un correo válido para continuar',

    // Registration Form
    registrationFormSuccessTitle: 'Enviado',
    registrationFormSuccess: 'El usuario se creó correctamente.',
    registrationFormSuccessContinueWithLogin:
        'El usuario se creó correctamente. Utiliza tu usuario y contraseña para loguearte.',

    // TrackingForm
    trackingSignatureImageAlt: 'Firma',
    trackingFormTitle: 'Tracking',
    trackingFormDescription: 'Ingresá tu código de tracking',
    trackingFormCode: 'Código',
    trackingFormSubmit: 'Buscar',
    trackingFormResponseEmpty: 'Su orden todavía no ha sido procesada',
    noMessageForEvent: 'No se encuentra el mensaje del evento',

    trackingStandardMessageText:
        'El paquete fue retirado del Locker Pudo ubicado en {{address}} el día {{date}}.\n',
    trackingShipToAddressMessageText:
        'El paquete fue entregado en {{address}} el día {{date}}.\n',
    trackingShipToAddressReverserLogisticMessageText:
        'El paquete fue retirado de {{address}} el día {{date}}.\n',
    trackingDeliveredToCourierReverserLogisticMessageText:
        'El paquete fue entregado a la tienda el día {{date}}.\n',
    trackingCollectedByMessageText: 'Retirado por: ',
    trackingDeliveredToMessageText: 'Entregado a: ',
    trackingReverseLogisticMessageText: 'Entregado por: ',
    trackingLinkLabel: 'Compartir',
    trackingLinkShareLink: ' Copiar el enlace',
    trackingLinkSendMail: 'Enviar un mail',
    trackingLinkSendWhatsAppMessage: 'Enviar un WhatsApp',
    trackingWhatsAppBody:
        'Podes seguir tu paquete haciendo click en el link: \n',
    trackingMailBody: 'Podes seguir tu paquete haciendo click en el link: \n',
    trackingMailSubjec: 'Segui tu envio de Pudo!',
    trackingSendCollectCode: 'Enviar cód. de Retiro',

    // Dialog
    dialogOkLabel: 'Ok',
    dialogCancelLabel: 'Cancelar',
    dialogDefaultTitle: 'Ooops..',
    dialogDefaultMessage: '',

    // Reverse Logistics
    reverseLogisticsNewTitle: 'Logistica Inversa',
    reverseLogisticsHeader: 'Ingresa los datos para Logística Inversa',
    reverseLogisticsSelectSizeTitle: 'Seleccione el tamaño del paquete',
    reverseLogisticsSelectSizeAccept: 'Siguiente',
    reverseLogisticsLockersTitle: 'Lockers disponibles tamaño ',
    reverseLogisticsSuccessfulCreationMessage:
        '¡Orden de Logística Inversa creada exitosamente!',
    reverseLogisticsReserveButton: 'Crear reserva',
    reverseLogisticsCreateButton: 'Crear orden de logística inversa',
    reverseLogisticsPostalCodeButton: 'Buscar servicios',
    reverseLogisticsShippingMethodsEmpty:
        'No hay servicios disponibles para el código postal ingresado',
    reverseLogisticsMethodsTitle: 'Servicios',
    reverseLogisticsDescription:
        'Acá podés crear órdenes de logística inversa para que llevemos paquetes a tu tienda, por ejemplo devoluciones. Tenemos dos servicios \n-El servicio de SmartLocker, en el cual al ser elegido le enviaremos a tu cliente con las instrucciones para depositar el paquete. El deposito tiene que ocurrir durante las proximas 48hs\n-El Servicio Domiciliario, en el cual enviaremos un mail detallado la preparacion del paquete para ser retirado. En este caso pasaremos a retirarlo apenas nos indiques que la orden esta lista para retirar (como haces con las otras ordenes).\n',

    // Order New
    orderNewTitle: 'Nuevo envio',
    orderNewCreateButton: 'Crear Orden',
    orderNewHeader: 'Ingresa los datos de envio',
    orderNewDescription: {
        noPlatform:
            'Acá podés crear órdenes de envío para todos tus ventas.\nCompletas los datos del destinatario, creas la orden y después operas como siempre.\n',
        shopify:
            'Acá podés crear órdenes de envío para todos los paquetes que no sean ventas de Shopify.\nCompletas los datos del destinatario, creas la orden y después operas como siempre.\n',
        tiendaNube:
            'Acá podés crear órdenes de envío para todos los paquetes que no sean ventas de TiendaNube.\nCompletas los datos del destinatario, creas la orden y después operas como siempre.\n',
        wooCommerce:
            'Acá podés crear órdenes de envío para todos los paquetes que no sean ventas de WooCommerce.\nCompletas los datos del destinatario, creas la orden y después operas como siempre.\n',
    },
    orderNewShippingMethodsTitle: 'Métodos de envío disponibles',
    orderNewLockersTitle: 'Lockers disponibles',
    orderNewAlias: 'Identificador',
    orderNewAliasPlaceholder: 'Ej. Para Felix Antonio',
    orderNewAddress: 'Dirección',
    orderNewShippingMethodsEmpty:
        'No hay métodos de envío para el código postal ingresado',
    orderNewSuccessfulCreationMessage: '¡Envio creado exitosamente!',
    notAllowedCharacters: 'No se permiten caracteres especiales',
    orderNewSearchButton: 'Buscar metodos de envio',
    all: 'todos',
    allCamel: 'Todos',
    dispatchToLockerTitle: 'Despacho en Locker',
    dispatchToLockerHeader: 'Ingresa los datos de despacho',
    dispatchToLockerDescription:
        'Acá podes crear ordenes de despacho para que busquemos tus paquetes en un locker en vez de ir a tu tienda.\nSolo tenes que ingresar un identificador y el locker que te quede más cómodo.\nCuando estes listo para dejar tus paquetes en el locker, elegí "Depositar en el locker" sobre la orden de despacho, seguí las instrucciones y listo!\nNo te olvides de colocar todos los paquetes en bolsa o caja al momento de depositar.\n',
    dispatchToLockerDescriptions: {
        1: 'Acá podes crear ordenes de despacho para que busquemos tus paquetes en un locker en vez de ir a tu tienda.\nSolo tenes que ingresar un identificador y el locker que te quede más cómodo.\nVas a tener 48hs para dejar tus paquetes en el locker.\nNo te olvides de colocar todos los paquetes en bolsa o caja al momento de depositar.\n',
    },
    dispatchToLockerCreateButton: 'Crear Despacho',
    dispatchToLockerAliasPlaceholder: 'Ej. Ordenes 0-12',
    dispatchToLockerAliasPrefix: 'Despacho',
    dispatchToLockerMail: 'box2box@pudolatam.com',
    dispatchToLockerSuccessfulCreationMessage: '¡Despacho creado exitosamente!',
    dispatchToLockerShippingMethodSmartLockerLabel: 'Smart Locker',
    dispatchToLockerSearchButton: 'Buscar lockers',
    dispatchToLockerShippingMethodsTitle: '',
    dispatchToLockerMethodsEmpty:
        'No hay lockers para despacho en el código postal ingresado',

    //shippingMethod
    shippingMethods: {
        standard: 'Smart Locker',
        instantPickup: 'Smart Locker - RetiraYa!',
        shipToAddress: 'Servicio a Domicilio',
    },

    //Order
    orderStateLabel: 'Estado',
    orderState: {
        registered: 'Creada',
        pendingIncidentResolution: 'Pendiente de Resolución',
        reserved: 'Listo para depositar',
        waitingPickup: 'Listo para Retiro',
        pendingReservation: 'Pendiente de Reserva',
        customerPickup: 'Paquete Entregado',
        abandoned: 'Paquete Abandonado',
        abandonedCollected: 'Paquete Abandonado Recuperado',
        deposited: 'Paquete Depositado en Locker',
        depositExpired: 'Tiempo para Deposito Expirado',
        parcelCollected: 'En posesión del transportista',
        inFacility: 'En Depósito',
        inTransit: 'En Tránsito',
        cancelled: 'Cancelada',
        expired: 'Expirado - Comuniquese con Pudo',
        pendingPayment: 'Pendiente de Pago',
        paid: 'Pago Recibido',
        returnToSender: 'Marcado para Retornar a Remitente',
        outForDelivery: 'En Ruta de Entrega',
        courierDelivered: 'Entregado a Tienda',
        lockerPickup: 'Retirado de Locker',
        unableToPickup: 'Terminado sin Retiro',
    },
    dispatchOrderState: {
        customerPickup: 'Retirado por Pudo',
    },
    orderStateFilter: {
        registered: 'Creada',
        pendingIncidentResolution: 'Pendiente de Resolución',
        reserved: 'Listo para depositar',
        waitingPickup: 'Listo para Retiro',
        pendingReservation: 'Pendiente de Reserva',
        customerPickup: 'Paquete Entregado/Retirado',
        abandoned: 'Paquete Abandonado',
        abandonedCollected: 'Paquete Abandonado Recuperado',
        deposited: 'Paquete Depositado en Locker',
        depositExpired: 'Tiempo para Depósito Expirado',
        parcelCollected: 'Retirado de Tienda',
        inFacility: 'En Depósito',
        inTransit: 'En Tránsito',
        cancelled: 'Cancelada',
        expired: 'Expirado',
        pendingPayment: 'Pendiente de Pago',
        paid: 'Pago Recibido',
        returnToSender: 'Marcado para Retornar a Remitente',
        outForDelivery: 'En Ruta de Entrega',
        courierDelivered: 'Entregado a Tienda',
        lockerPickup: 'Retirado de Locker',
        unableToPickup: 'Terminado sin Retiro',
        orderWaitingPickUpLimit: 'Esperando cantidad mínima de retiros',
    },
    //Reservation state
    reservationStates: {
        new: 'Nueva',
        canceled: 'Cancelada',
        expiredNotConfirmed: 'Expirada sin confirmación',
        confirmed: 'Pendiente de depósito en locker',
        expiredNotDeposited: 'Expirada sin depositar',
        canceledNotDeposited: 'Cancelada sin depositar',
        deposited: 'Depositada',
        canceledDeposited: 'Depositada y cancelada',
        canceledDepositedCollected: 'Depósito cancelado y recolectada',
        expiredNotCollected: 'Expirada y no recolectada',
        collected: 'Recolectada',
        abandoned: 'Abandonada',
        abandonedCollected: 'Abandonada y recolectada',
        canceledParcelMissing: 'Cancelada y Faltante',
    },

    //Event type names
    eventTypes: {
        newLockerConfiguration: 'Nueva configuración de locker',
        reservationConfirmed: 'Reserva confirmada',
        reservationDeposited: 'Listo para retiro en el locker',
        reservationCollected: 'Retirado',
        reservationDepositWhenNotIdle: 'El locker no esta listo para depósitar',
        reservationDepositAbandoned: 'Depósito abandonado',
        reservationDepositExpired: 'Depósito expirado',
        reservationDepositDoorLocked: 'Puerta trabada intentado de depositar',
        reservationDepositPackageFound:
            'Había un paquete al intentar depositar',
        reservationDepositDoorOpenedAndPackageNotFound:
            'La puerta del locker se abrió y no se encontró paquete',
        reservationDepositDoorOpenedAndPackageFound:
            'La puerta del locker se abrió y se encontró el paquete',
        reservationPickupCompleted: 'Paquete retirado',
        reservationPickupExpired: 'Expiró el tiempo de retiro',
        reservationPickupWhenNotIdle: 'El locker no esta listo para retirar',
        reservationPickupDoorLocked: 'Puerta trabada al intentar retirar',
        reservationPickupPackageMissing:
            'Al retirar, no se encontró el paquete',
        reservationPickupDoorOpenedAndPackageNotFound:
            'La puerta del locker se abrió y no se encontró paquete',
        reservationPickupDoorOpenedAndPackageFound:
            'La puerta del locker se abrió y se encontró paquete',
        reservationDepositTimerExpired: 'Expiró el tiempo para depositar',
        reservationDepositTimerExpiresSoon:
            'Plazo de deposito próximo a vencer',
        reservationPickupTimerExpired: 'Expiró el tiempo para retirar',
        reservationPickupTimerExpiresSoon: 'Plazo de retiro próximo a vencer',
        reservationParcelMissing: 'No se encontró paquete',
        reservationCancellationRequest: 'Pedido de cancelación de reserva',
        reservationCancellationResult: 'Cancelación de reserva',
        reservationAbandoned: 'Paquete abandonado',
        reservationCollectedByTechnician: 'Reserva recolectada por un técnico',
        reservationAbandonedCollected: 'Paquete abandonado recolectado',
        reservationAbandonedPickupCompleted: 'Paquete abandonado retirado',
        reservationAbandonedPickupExpired:
            'Expiró el tiempo de retiro del paquete abandonado',
        reservationAbandonedPickupWhenNotIdle:
            'El locker no esta listo para retirar',
        reservationAbandonedPickupDoorLocked:
            'Puerta trabada al retirar paquete abandonado',
        reservationAbandonedPickupPackageMissing:
            'No se encontró paquete al intentar retirar',
        reservationAbandonedPickupDoorOpenedAndPackageNotFound:
            'La puerta del locker se abrió y no se encontró el paquete abandonado',
        reservationAbandonedPickupDoorOpenedAndPackageFound:
            'La puerta del locker se abrió y se encontró el paquete abandonado',
        newServiceAccessConfiguration: 'Nueva configuración',
        technicianLogin: 'Log in del técnico',
        technicianLogout: 'Log out del técnico',
        technicianOpenDoor: 'El técnico abrió una puerta',
        technicianOpenDoorRequested: 'El técnico solicitó abrir una puerta',
        technicianOpenDoorRequestTimedOut:
            'La solicitud de apertura de puerta del técnico expiró',
        technicianStatusChangedDoorOpenedPackagePresent:
            'El técnico cambió el estado, se abrió la puerta y esta el paquete',
        technicianStatusChangedDoorOpenedPackageNotPresent:
            'El técnico cambió el estado, se abrió la puerta y no esta el paquete',
        technicianStatusChangedDoorClosedPackagePresent:
            'El técnico cambió el estado, se cerró la puerta y el paquete está',
        technicianStatusChangedDoorClosedPackageNotPresent:
            'El técnico cambió el estado, se cerró la puerta y el paquete ya no está',
        expectedStatusChanged: 'Se espera un cambio de estado',
        expectedStatusOpeningDoor: 'Se espera que esté abriendo al puerta',
        inconsistencyDetectedDoorNotFound:
            'Inconsistencia detectada, no se encontró la puerta',
        inconsistencyDetectedReservationPackageMissing:
            'Inconsistencia detectada, falta el paquete',
        inconsistencyDetectedReservationDoorOpened:
            'Inconsistencia detectada, la puerta de la reserva se abrió',
        inconsistencyDetectedUnexpectedPackageFound:
            'Inconsistencia detectada, se encontró un paquete que no debería estar',
        inconsistencyDetectedDoorLeftOpened:
            'Inconsistencia detectada, la puerta quedó abierta',
        configurationParamUpdate: 'Se actualizó la configuración',
        lockerStateUpdate: 'Se actualizó el estado del locker',
        reservationExtended: 'Reserva Extendida',
        reservationPickupInvalidSecurityCode: 'Intento de retiro fallido',
        incidence: 'Incidencia',
        depositOrPickupFailed: 'Falló el deposito o el retiro',
        reservationCancelled: 'Reserva Cancelada',
        reservationCancelledCollected: 'Paquete cancelado retirado',
        reservationCancelledPickupCompleted: 'Paquete cancelado retirado',
        reservationCancelledPickupExpired:
            'Expiró el tiempo de retiro del paquete cancelado',
        reservationCancelledPickupWhenNotIdle:
            'El locker no esta listo para retirar',
        reservationCancelledPickupDoorLocked:
            'Puerta trabada al retirar paquete cancelado',
        reservationCancelledPickupPackageMissing:
            'No se encontró paquete al intentar retirar',
        reservationCancelledPickupDoorOpenedAndPackageNotFound:
            'La puerta del locker se abrió y no se encontró el paquete cancelado',
        reservationCancelledPickupDoorOpenedAndPackageFound:
            'La puerta del locker se abrió y se encontró el paquete cancelado',
        recoverReservationRequest: 'Se pidió la recuperación de la reserva',
        recoverReservationResult:
            'Se respondió al pedido de recuperación de la reserva',

        //securitytoken events
        securityTokenGenerated: 'Se ha generado un token de seguridad',
        securityTokenValid: 'Se ha validado exitosamente el token de seguridad',
        securityTokenInvalid: 'Se ha ingresado un token de seguridad no válido',
    },

    // CourierParcel event type names
    courierParcelEventTypes: {
        created: 'Registrada',
        markedForPickUp: 'Paquete preparado',
        parcelPickUp: 'En posesión del transportista',
        arrivalAtFacility: 'En Depósito',
        waitingReservation: 'Esperando reserva',
        reserved: 'Procesada',
        expired: 'Expirada',
        cancelled: 'Cancelado',
        waitingCourierConfirmation: 'Espera confirmación',
        waitingIncidenceResolution: 'Espera resolución de incidencia',
        inTransit: 'En Transito',
        departureFromFacility: 'Salida de Depósito',
        delivered: 'Entregado',
        deliverAttempt: 'Intento de Entrega',
        returnToSender: 'Retornar a Remitente',
        outForDelivery: 'En Ruta de Entrega',
        pickupAttempt: 'Intento de Recolección',
        courierDeliver: 'Entregado a Tienda',
        lockerPickup: 'Retiro en Locker',
        unableToPickup: 'Terminado sin Retiro',
        addressEditByCourier: 'Dirección modificada',
    },

    // externalHauler event type names
    externalHaulerStates: {
        ShipmentCreated: 'Envío creado',
        ShippingWithdrawn: 'Envío retirado',
        ShippingSupported: 'Envío admitido',
        ShipmentProcessed: 'Envío procesado',
        ShippingInTransitToTheDestinationBranch: 'Envío en viaje a Sucursal destino',
        ShipmentReceivedAtDestinationBranch: 'Envío recibido en Sucursal destino',
        ShipmentAwaitingPickupAtBranch: 'Envío en espera de retiro en Sucursal',
        ShippingScheduledForVisit: 'Envío programado para visita',
        StreetDelivery: 'Envío en calle',
        ShipmentDelivered: 'Envío entregado',
        ShipmentNotDelivered: 'Envío no entregado',
        ReturnShipping: 'Envío en devolución'
    },

    exceptions: {
        DefaultException: 'Ocurrió un error, intente nuevamente más tarde.',
        NetworkError: 'Ocurrió un error, intente nuevamente más tarde.',
        DownloadError: 'Ocurrió un error, intente nuevamente más tarde.',
        invalid_grant: 'Los datos de autenticación no son válidos.',
        InvalidCaptchaException: 'No pudimos validar los datos, por favor reintente.',
        CredentialsExpired: 'Por favor ingrese nuevamente a la aplicacion.',
        UnsupportedShopStateException: 'Estado del Shop no soportado',
        InvalidRequestException: 'Ocurrió un error con los datos ingresados, intente nuevamente.',
        ApplicationException: 'Ocurrió un error, intente nuevamente más tarde.',
        UnhandledException: 'Ocurrió un error, intente nuevamente más tarde.',
        ShopNotActivatedException: 'La tienda no puede operar. Comuniquese con Pudo a la brevedad',
        ChangePasswordErrorException: 'No se pudo cambiar la contraseña, verificá los datos ingresados.',
        OrderNotFoundExceptYion: 'No se encontró la orden.',
        ReservationNotFoundException: 'No se encontró la reserva.',
        LockerNotFoundException: 'No se encontró el locker.',
        PackageNotFoundException: 'No se encontró el paquete.',
        ShopNameAlreadyExistsException: 'Ya existe una tienda con ese nombre. Debe registrar su tienda con otro nombre. Si ya esta registrado y no recuerda su mail, contactese con PUDO.',
        ShopUserExistsException: 'El usuario ya existe. Si no recuerda su contraseña recuperala en la pagina principal.',
        PostalCodeNotFoundException: 'Código Postal no encontrado',
        ShopUserExistInDifferentShop: 'El usuario ya existe en otra tienda. Si no recuerda su contraseña recuperala en la pagina principal.',
        ShopAlreadyExistsException: 'Ya existe una tienda con ese nombre. Debe registrar su tienda con otro nombre. Si ya esta registrado y no recuerda su mail, contactese con PUDO.',
        ShopNotFoundException: 'La tienda no puede operar. Comuniquese con Pudo a la brevedad',
        TokenNotFoundException: 'Ocurrió un error, intente nuevamente desde el comienzo.',
        EndUserTicketTemplateNotFoundException: 'Ocurrió un error, intente nuevamente desde el comienzo.',
        WarehouseNotFoundException: 'La tienda no puede operar al no tener Depósito asignado. Comuniquese con Pudo a la brevedad',
        ServiceAreaNotFoundException: 'La tienda no puede operar en el Area de Servicio. Comuniquese con Pudo a la brevedad',
        CouldNotReserveException: 'No se pudo generar la reserva, intente nuevamente más tarde.',
        CanNotCancelWithoutIncidenceException: 'No se puede cancelar la reserva',
        TaxingCategoryNotValidException: 'Lamentablemente. Su condicion frente al IVA no esta habilitada para operar.',
        IdentificationInactiveException: 'El numero ingresado no se corresponde con un CUIT activo',
        IdentificationTypeNotValidException: 'El numero ingresado no se corresponde con un CUIT',
        BillingInformationInvalidFormatException: 'El numero ingresado no tiene un formato valido',
        BillingInformationQueryFailedException: 'Lamentablemente no pudimos validar tu CUIT. Reintenta mas tarde.',
        UnsupportedOrderEventException: 'No se puede realizar la operación sobre la orden.',
        NoReservationsLockerSpaceAvailable: 'No hay espacio disponible en el locker. Reintente nuevamente luego.',
        MaxReservationTimeExceededException: 'Se excedió el tiempo máximo que se puede reservar.',
        SomeOrdersNotCanceledException: 'El estado de algunas ordenes no permiten cancelacion',
    },

    // Codigos de recoleccion
    collectionSecurityCodeTypes_noSecurityCodePresent: 'Ninguna',
    collectionSecurityCodeTypes_dni: 'DNI',
    collectionSecurityCodeTypes_alphaNumeric: 'Documento',

    //Order Types
    orderTypesPrefix: {
        eCommerce: 'Orden #',
        noPlatform: '',
        dispatch: '',
        reverseLogistic: '',
    },
    orderTypesLabel: 'Tipo de orden',
    orderTypes: {
        eCommerce: 'Orden de Tienda',
        noPlatform: 'Orden de Envio',
        dispatch: 'Orden de Despacho',
        reverseLogistic: 'Orden de Logística Inversa',
    },
    orderTypeTooltip: {
        eCommerce: 'Orden de Tienda',
        noPlatform: 'Orden de Envio',
        dispatch: 'Orden de Despacho',
        reverseLogistic: 'Orden de Logística Inversa',
    },

    //News
    restrictiveNew: {
        atention: 'Atención',
        agree: 'He leído y acepto el contenido mostrado',
        closeBtn: 'Cerrar',
    },
    criticalNew: {
        title: 'Atención',
        closeBtn: 'Salir',
    },
    newsPanel: {
        newsTitle: 'Noticias',
        newNews: 'Nuevas',
        acceptType: 'Aceptar',
        readType: 'Leído',
        confirm: 'Confirmo que he leído',
        mustConfirm: 'Debe confirmar',
        read: 'Leídas',
        more: 'Ver más',
        noReadNews: 'No tiene noticias leídas',
        noUnreadNews: 'No tiene noticias sin leer',
        newFromDate: 'Fecha: ',
        newToDate: 'Válido hasta: '
    },
    newsResume: {
        newNews: 'Tenés noticias nuevas',
        noNews: 'No hay noticias nuevas',
        seeAll: 'Ver todo',
    }

}
